"use strict";
/**
 * Locked Checker copy from the Renovation Payment Schedule Checker tool doc.
 * Bump `CHECKER_COPY_VERSION` when Product changes wording.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKER_CONTRACT_CHECKLIST = exports.CHECKER_PASS_COPY = exports.CHECKER_FINDING_COPY = exports.CHECKER_COPY_VERSION = void 0;
exports.CHECKER_COPY_VERSION = "2026-10-23";
/** Finding copy (locked), keyed by check number. */
exports.CHECKER_FINDING_COPY = {
    1: {
        title: "Your deposit is over 20%",
        whyItMatters: "Before works start, no work has been done. Most ID contracts include a no-refund clause or cancellation penalty, so the higher the deposit, the more you're exposed if the project falls apart early.",
        recommendation: "Ask your ID to bring the deposit down to a maximum of 20%.",
    },
    2: {
        title: "There's a payment over 50%",
        whyItMatters: "You're paying more than half your budget before the work at that stage is complete. If quality falls short or work stalls, that money is already out.",
        recommendation: "Ask your ID to split this into two separate milestone payments.",
    },
    3: {
        title: "There's no handover payment",
        whyItMatters: "Once you've paid in full, your ID has no financial reason to come back and fix defects. The handover payment is what keeps them accountable at the end. Without it, getting issues resolved becomes a favour, not an obligation.",
        recommendation: "Ask your ID to include a handover payment milestone of at least 5%.",
    },
    4: {
        title: "Your handover payment is under 5%",
        whyItMatters: "Industry norm is to hold back at least 5% at handover. Below that, there's little left to motivate your ID to return for defect fixes. Once it's paid, there's nothing left to hold back.",
        recommendation: "Ask your ID to increase the handover payment to a minimum of 5%.",
    },
    5: {
        title: "There are fewer than 4 payments",
        whyItMatters: "Fewer payments means larger transfers at each stage, with less visibility into whether the work is actually done. If something goes wrong mid-project, you've paid out more with less room to push back.",
        recommendation: "Ask your ID to add a works start and carpentry milestone, bringing payments to a minimum of 4 stages.",
    },
    6: {
        title: "Your first 2 payments are over 50%",
        whyItMatters: "More than half your budget is paid before most of the work has begun. If the project stalls early, you've already paid the majority of your renovation cost.",
        recommendation: "Ask your ID to keep your first 2 payments to a maximum of 50%.",
    },
};
/**
 * Pass lines for checks that pass. Order matches report display.
 * Handover checks 3 and 4 share one line when handover ≥ 5%.
 */
exports.CHECKER_PASS_COPY = [
    { checkIds: [1], line: "Deposit is 20% or less" },
    { checkIds: [2], line: "No single payment over 50%" },
    { checkIds: [6], line: "First 2 payments are 50% or less" },
    { checkIds: [3, 4], line: "Handover payment is at least 5%" },
    { checkIds: [5], line: "At least 4 payments" },
];
/** Always shown on the full report (Before You Sign). */
exports.CHECKER_CONTRACT_CHECKLIST = [
    "Check what happens to your deposit if you cancel before works start.",
    "Each payment should be tied to a clear, checkable milestone.",
    "Check how long your ID will fix defects after handover.",
    "Check how variation orders are agreed and charged before work begins.",
];
